var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "app-toast",
    { staticClass: "confirm-subscription", attrs: { message: _vm.message } },
    [
      _c("div", {
        staticClass: "toast-body",
        domProps: { innerHTML: _vm._s(_vm.$t("toasts.confirm-subscription")) }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }